import React from 'react';
import { Check, CloudOff, Loader2, AlertCircle } from 'lucide-react';

const formatTime = (date) => (date ? date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '');

const SaveStatus = ({ status, lastSavedAt, onRetry, className = '' }) => {
  let content = null;
  if (status === 'saving') {
    content = (<><Loader2 className="h-4 w-4 animate-spin text-gray-400" aria-hidden="true" /><span>Saving…</span></>);
  } else if (status === 'saved' || (status === 'idle' && lastSavedAt)) {
    content = (<><Check className="h-4 w-4 text-green-600" aria-hidden="true" /><span>Saved{lastSavedAt ? ` at ${formatTime(lastSavedAt)}` : ''}</span></>);
  } else if (status === 'offline') {
    content = (<><CloudOff className="h-4 w-4 text-amber-500" aria-hidden="true" /><span>Offline. Changes will save when you reconnect.</span></>);
  } else if (status === 'error') {
    content = (
      <>
        <AlertCircle className="h-4 w-4 text-red-500" aria-hidden="true" />
        <span>Couldn't save.</span>
        {onRetry && (
          <button type="button" onClick={onRetry} className="font-medium text-blue-700 underline underline-offset-2 hover:text-blue-900">
            Retry
          </button>
        )}
      </>
    );
  } else {
    content = <span className="text-gray-500">Autosave on</span>;
  }

  return (
    <div className={`inline-flex items-center gap-1.5 text-xs text-gray-600 ${className}`} aria-live="polite" role="status">
      {content}
    </div>
  );
};

export default SaveStatus;
